module.exports = __webpack_public_path__ + "img/10.bba4cfc1.png";